import Page from "./Page";
import reducer from "./reducer";

export const reducers = {
  RegionManager: reducer,
};

export default {
  Page,
  reducers,
};